import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiSearchIcon from "@mui/icons-material/Search";
import MuiDeleteIcon from "@mui/icons-material/Delete";
import MuiTextField from "@mui/material/TextField";
import MuiFolderOpenIcon from "@mui/icons-material/FolderOpen";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelClient from "../../model/custom/Client";
import ControllerClientList from "../../controller/custom/ClientList";
import ControllerUserList from "../../controller/UserList";
import ControllerLocalization from "../../controller/Localization";
import ViewLoader from "../Loader";
import ViewPagination from "../Pagination";
import ViewDialog from "../Dialog";

let isRendered = false;

const viewPageClientList: React.FC<ModelClient.Iprops> = (props) => {
    // Variable
    const controllerClientList = new ControllerClientList(isRendered);
    const controllerUserList = new ControllerUserList(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerClientList.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    const clientListAutocompleteSlotProps = HelperSrc.createAutocompleteSlotProps("view_list_popper", [0, 0]);

    if (
        controllerLocalization.getStorageMain &&
        controllerClientList.getSelectOption &&
        controllerClientList.getPagination &&
        controllerClientList.getFilter &&
        controllerClientList.getDataMainList
    ) {
        return (
            <div className="view_client_list" data-at_id="view_client_list">
                <div className="button_container">
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (HelperSrc.checkRole(controllerUserList.getStorageRole, ["superuser"], props.userData)) {
                            html.push(
                                <MuiButton
                                    className="button_primary"
                                    data-at_id="button_create_client"
                                    disabled={controllerClientList.getApiLoadingList.selectOption}
                                    onClick={() => {
                                        controllerClientList.clickCreate();
                                    }}
                                >
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        if (controllerClientList.getApiLoadingList.selectOption) {
                                            html.push(<MuiCircularProgress className="icon_progress" />);
                                        } else {
                                            html.push(<>{controllerLocalization.getStorageMain.create}</>);
                                        }

                                        return html;
                                    })()}
                                </MuiButton>
                            );
                        }

                        return html;
                    })()}
                </div>
                <table>
                    {(() => {
                        const html: JSX.Element[] = [];

                        html.push(
                            <>
                                <colgroup>
                                    <col className="cell id" />
                                    <col className="cell username" />
                                    <col className="cell username_kana" />
                                    <col className="cell update_date" />
                                    <col className="cell update_by" />
                                    <col className="cell" />
                                </colgroup>
                                <thead className="filter">
                                    <tr className="row filter_action">
                                        <td>
                                            <MuiButton
                                                className="button_primary container_button"
                                                data-at_id="button_apply"
                                                disabled={controllerClientList.getApiLoadingList.selectOption}
                                                onClick={() => {
                                                    controllerClientList.clickFilterApply();
                                                }}
                                            >
                                                {(() => {
                                                    const html: JSX.Element[] = [];

                                                    if (controllerClientList.getApiLoadingList.selectOption) {
                                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                                    } else {
                                                        html.push(
                                                            <span className="button_label">
                                                                {controllerLocalization.getStorageMain.apply} <MuiSearchIcon />
                                                            </span>
                                                        );
                                                    }

                                                    return html;
                                                })()}
                                            </MuiButton>
                                        </td>
                                    </tr>
                                    <tr className="row not_hover client_list_table">
                                        <th className="cell field_container">{controllerLocalization.getStorageMain.id}</th>
                                        <th data-at_id="th_client" className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={clientListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerClientList.getSelectOption.username)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li
                                                                {...props}
                                                                data-at_id={`select_client_${option.display_name ? option.display_name : "select"}`}
                                                            >
                                                                {option.display_name || controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="username"
                                                        data-at_id="input_client"
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.username
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={clientListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerClientList.getSelectOption.username_kana)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li {...props}>{option.display_name || controllerLocalization.getStorageMain.select}</li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="username_kana"
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.username_kana
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={clientListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerClientList.getSelectOption.latest_update)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li className="date" {...props}>
                                                                {option.display_name
                                                                    ? HelperSrc.localeFormat(new Date(option.display_name))
                                                                    : controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="latest_update"
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.latest_update
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={clientListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(
                                                        controllerClientList.getSelectOption.latest_update_by_id
                                                    )) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li {...props}>{option.display_name || controllerLocalization.getStorageMain.select}</li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <div>
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.latest_update_by
                                                                    : ""
                                                            }
                                                        />
                                                        <input
                                                            type="hidden"
                                                            className="field_value"
                                                            name="latest_update_by_id"
                                                            defaultValue={controllerClientList.getElementLatestUpdateByIdValue}
                                                        />
                                                    </div>
                                                )}
                                                onChange={(_, option) => {
                                                    if (option && controllerClientList.setElementLatestUpdateByIdValue) {
                                                        controllerClientList.setElementLatestUpdateByIdValue(option.value as string);
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th className="cell field_container"></th>
                                    </tr>
                                </thead>
                            </>
                        );

                        return html;
                    })()}
                    <tbody className="client_list_table" data-at_id="tbody_client_list">
                        {(() => {
                            const html: JSX.Element[] = [];

                            if (controllerClientList.getApiLoadingList.list) {
                                html.push(
                                    <tr className="row_empty">
                                        <td>
                                            <MuiCircularProgress className="icon_progress" />
                                        </td>
                                    </tr>
                                );
                            } else {
                                if (!controllerClientList.getPagination || Object.entries(controllerClientList.getPagination.data).length === 0) {
                                    html.push(
                                        <tr className="empty_state">
                                            <td colSpan={100}>
                                                <MuiFolderOpenIcon className="icon" />
                                                <p>{controllerLocalization.getStorageMain.no_result}</p>
                                            </td>
                                        </tr>
                                    );
                                } else {
                                    for (const [key, data] of Object.entries(controllerClientList.getDataMainList)) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        html.push(
                                            <tr
                                                className={`row ${alternateRow}`}
                                                data-at_id={`tr_list_data_${data.id}`}
                                                onClick={(event) => {
                                                    controllerClientList.clickItem(event, data);
                                                }}
                                            >
                                                <td className="cell">{data.id}</td>
                                                <td className="cell" data-at_id="td_client_name">
                                                    {data.username}
                                                </td>
                                                <td className="cell">{data.username_kana}</td>
                                                <td className="cell">
                                                    {data.latest_update ? HelperSrc.localeFormat(new Date(data.latest_update)) : ""}
                                                </td>
                                                <td className="cell">
                                                    {(() => {
                                                        for (const optionData of Object.values(
                                                            controllerClientList.getSelectOption.latest_update_by_id
                                                        )) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            if (data.latest_update_by_id === optionDataTyped.value) {
                                                                return optionDataTyped.display_name;
                                                            }
                                                        }
                                                    })()}
                                                </td>
                                                <td className="cell center">
                                                    {(() => {
                                                        const html: JSX.Element[] = [];

                                                        if (
                                                            HelperSrc.checkRole(
                                                                controllerUserList.getStorageRole,
                                                                ["superuser", "manager"],
                                                                props.userData
                                                            )
                                                        ) {
                                                            html.push(
                                                                <MuiDeleteIcon
                                                                    data-at_id="icon_delete"
                                                                    className="button_icon"
                                                                    onClick={(event) => controllerClientList.clickRemove(event, data.id)}
                                                                />
                                                            );
                                                        }

                                                        return html;
                                                    })()}
                                                </td>
                                            </tr>
                                        );
                                    }
                                }
                            }

                            return html;
                        })()}
                    </tbody>
                </table>
                <ViewPagination response={controllerClientList.getPagination} api={controllerClientList.apiDataList} />
                <ViewDialog
                    className="client_remove_dialog"
                    isOpen={controllerClientList.getIsDialogOpen}
                    isApiLoading={controllerClientList.getApiLoadingList.removeData}
                    labelConfirm={controllerLocalization.getStorageMain.yes}
                    onClickConfirm={controllerClientList.clickDialogRemoveConfirm}
                    labelCancel={controllerLocalization.getStorageMain.no}
                    onClickCancel={controllerClientList.clickDialogRemoveCancel}
                    mode={"alert"}
                    content={controllerLocalization.getStorageMain.delete_record}
                />
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageClientList;
